import {
  SES_CONTROL_MODAL_SEGURADO_ESPECIAL,
  SES_ZERAR_DECLARACAO_SEGURADO_ESPECIAL,
  SET_ERRO_SEGURADO_ESPECIAL,
  SES_BUSCAR_PERIODO_ATIVIDADE_SUCESSO,
  BUSCAR_DECLARACAO_SEGURADO_ESPECIAL_ERRO,
  ATUALIZAR_DECLARACAO_SEGURADO_ESPECIAL,
  LISTAR_DECLARACOES_SEGURADO_ESPECIAL_POR_ID_TAREFA_SUCESSO,
  LISTAR_DECLARACOES_SEGURADO_ESPECIAL_POR_ID_TAREFA_ERRO,
  SET_DECLARACAO_SEGURADO_ESPECIAL_ID_TAREFA,
  SES_CONSULTAR_ID_TAREFA_POR_PROTOCOLO_SUCESSO,
  SET_DECLARACAO_SEGURADO_ESPECIAL_TIPO_DECLARACAO,
  SET_DECLARACAO_SEGURADO_ESPECIAL_SITUACAO_FAMILIAR,
  SET_DECLARACAO_SEGURADO_ESPECIAL_CONDICAO_IMOVEL,
  SET_DECLARACAO_SEGURADO_ESPECIAL_DT_INICIO,
  SET_DECLARACAO_SEGURADO_ESPECIAL_DT_FIM,
  SET_DECLARACAO_SEGURADO_ESPECIAL_CODIGO_LOCAL_EXERCE_ATIVIDADE_PESCADOR,
  SET_DECLARACAO_SEGURADO_ESPECIAL_LOCAL_ATIVIDADE_RURAL,
  SET_PERIODO_ATIVIDADE_NUMERO_RGP,
  SET_DECLARACAO_SEGURADO_ESPECIAL_NUMERO_RGP,
  SET_DECLARACAO_SEGURADO_ESPECIAL_EXPORTACAO_SUSTENTAVEL,
  SET_DECLARACAO_SEGURADO_ESPECIAL_ACEITE_FINALIZAR_REQUERIMENTO,
  SES_CONSULTAR_ADIAR_PREENCHIMENTO_DE_AUTODECLARACAO_SUCESSO,
  SES_ADIAR_PREENCHIMENTO_DE_AUTODECLARACAO_SUCESSO,
  SET_DECLARACAO_SEGURADO_ESPECIAL_INFORMACOES_VERDADEIRAS,
  SET_DECLARACAO_SEGURADO_ESPECIAL_EH_PRODUTOR_RURAL_PESCADOR_SERINGUEIRO,
  SET_DECLARACAO_SEGURADO_ESPECIAL_EH_INDIGENA,
  SET_DECLARACAO_SEGURADO_ESPECIAL_EH_EMPREGADO_RURAL,
  SET_DECLARACAO_SEGURADO_ESPECIAL_NOME,
  SET_DECLARACAO_SEGURADO_ESPECIAL_DT_NASCIMENTO_COMPONENTE,
  SET_DECLARACAO_SEGURADO_ESPECIAL_LOCAL_NASCIMENTO,
  SET_DECLARACAO_SEGURADO_ESPECIAL_ENDERECO_RESIDENCIAL,
  SET_DECLARACAO_SEGURADO_ESPECIAL_NUMERO_CEI,
  SET_DECLARACAO_SEGURADO_ESPECIAL_UF,
  SET_DECLARACAO_SEGURADO_ESPECIAL_MUNICIPIO,
  SET_DECLARACAO_SEGURADO_ESPECIAL_NU_RG,
  SET_DECLARACAO_SEGURADO_ESPECIAL_LOCAL_EXPEDICAO,
  SET_DECLARACAO_SEGURADO_ESPECIAL_DATA_EXPEDICAO,
  SET_DECLARACAO_SEGURADO_ESPECIAL_CPF,
  SET_DECLARACAO_SEGURADO_ESPECIAL_APELIDO,
  SES_CESSAO_DE_TERRA_CADASTRAR_SUCESSO,
  SES_CESSAO_DE_TERRA_LISTAR_SUCESSO,
  SES_CESSAO_DE_TERRA_LIMPAR,
  SES_CESSAO_DE_TERRA_SET_CONFIRMAR,
  SES_CESSAO_DE_TERRA_SET_EXIBIR_MODAL_CESSAO_TERRA_EXCLUSAO,
  SES_GRUPOS_FAMILIARES_LISTAR_SUCESSO,
  SES_GRUPOS_FAMILIARES_SET_EXIBIR_MODAL_CESSAO_TERRA_EXCLUSAO,
  SES_GRUPOS_FAMILIARES_SET_CONDICAO_GRUPO_FAMILIAR,
  SES_COOPERATIVA_LISTAR_SUCESSO,
  SES_COOPERATIVA_SET_CONFIRMAR,
  SES_COOPERATIVA_LIMPAR,
  SES_LISTAR_ATIVIDADES_RURAIS_SUCESSO,
  SES_RECOLHIMENTO_IPI_LISTAR_SUCESSO,
  SES_RECOLHIMENTO_IPI_LIMPAR_SUCESSO,
  SES_RECOLHIMENTO_IPI_SET_CONFIRMAR,
  SES_PROPRIEDADE_RURAL_LISTAR_SUCESSO,
  SES_PROPRIEDADE_RURAL_SET_EXIBIR_MODAL_CESSAO_TERRA_EXCLUSAO,
  BUSCAR_DADOS_SEGURADOS_ESPECIAL_SUCESSO,
  SES_CONSULTAR_DADOS_INTERESSADOS_SUCESSO,
  SES_CONSULTAR_DADOS_SEGURADO_SUCESSO,
  SES_CADASTRAR_DADOS_SEGURADO_SUCESSO,
  SES_CADASTRAR_NUMERO_RGP_SUCESSO,
  SES_CONSULTAR_CATEGORIAS_ATIVIDADE_RURAL_SUCESSO,
  SES_CATEGORIAS_DECLARACAO_SUCESSO,
  SES_SELECAO_CATEGORIAS_SET_PRIMEIRO_CADASTRO,
  CADASTRAR_PERIODO_DECLARACAO_SEGURADO_ESPECIAL_SUCESSO,
  SES_CONSULTAR_MUNICIPIOS_POR_UF_SUCESSO,
  SES_PROPRIEDADE_RURAL_LIMPAR,
  SES_LIMPAR_GRUPOS_FAMILIARES,
  SES_LIMPAR_ATIVIDADES_RURAIS,
  SES_EMPREGADO_LIMPAR_SUCESSO,
  SES_EMPREGADO_SET_CONFIRMAR,
  SES_EMPREGADO_LISTAR_SUCESSO,
  SES_EXERCE_ATIVIDADE_RECEBE_OUTRA_RENDA_ESPECIFICA_LIMPAR,
  SES_OUTRAS_ATIVIDADES_ESPECIFICA_SET_CONFIRMAR,
  SES_OUTRAS_ATIVIDADES_SET_CONFIRMAR,
  SES_OUTRAS_ATIVIDADES_LISTAR_SUCESSO,
  SES_LISTAR_EXERCE_ATIVIDADE_RECEBE_OUTRA_RENDA_ESPECIFICA_SUCESSO,
  SES_RELACAO_PESCADOR_EMBARCACAO_CADASTRAR_SUCESSO,
  SES_CONDICAO_PESCADOR_EMBARCACAO_LISTAR_SUCESSO,
  SES_CONDICAO_PESCADOR_EMBARCACAO_LIMPAR,
  SES_TITULAR_LISTAR_SUCESSO,
  SES_TITULAR_LIMPAR_SUCESSO,
  SES_ARRENDAMENTO_EMBARCACAO_SET_CONFIRMAR,
  SES_ARRENDAMENTO_EMBARCACAO_LISTAR_SUCESSO,
  SES_ARRENDAMENTO_EMBARCACAO_LIMPAR_SUCESSO,
  SET_DECLARACAO_SEGURADO_ESPECIAL_PESSOA_QUILOMBOLA,
} from "./actionTypes"

import {
  condicaoEmRelacaoAoImovelEnum,
  getCodigoValuePorEnumValue
} from "./SESEnums";

const novaDeclaracaoSeguradoEspecialTO = {
  idPeriodoAtividadeRural: null,
  preenchimentoConcluido: false,
  cpf: "",
  localDaAtividadeRural: "",
  dadosSegurado: {
    idSegurado: null,
    idTarefa: null,
    nome: "",
    cpf: "",
    apelido: "não tenho apelido",
    dataNascimento: "",
    localNascimento: "",
    endereco: "",
    numeroMunicipio: "",
    siglaUF: "",
    numeroRG: "",
    localExpedicaoRg: "",
    dataExpedicaoRg: "",
    numeroRGP: "",
    numeroCEI: ""
  },
  idTarefa: null,
  categoriaAtividade: "",
  situacaoFamiliar: "",
  condicaoEmRelacaoAoImovel: "",
  condicaoNoGrupoFamiliar: "",
  dataInicio: "",
  dataFim: "",
  exploracaoSustentavel: false,
  codigoLocalExerceAtividadePescador: "",
  exibirModalCessaoTerraExclusao: false,
  ehObrigatorioCessaoTerra: "NULL",
  cessoesDeTerra: [],
  exibirModalPropriedadesRuraisExclusao: false,
  propriedadesRurais: [],
  ehObrigatorioOutrasAtividades: "NULL",
  outrasAtividades: [],
  ehObrigatorioCooperativas: "NULL",
  cooperativas: [],
  exibirModalGrupoFamiliaresExclusao: false,
  gruposFamiliares: [],
  atividadesRurais: [],
  ehObrigatorioRecolhimentosIPI: "NULL",
  recolhimentosIPI: [],
  ehObrigatorioEmpregadosPrestadoresServicos: "NULL",
  empregadosOuPrestadores: [],
  ehObrigatorioAtividadesEspecificas: "NULL",
  atividadesEspecificas: [],
  aceiteFinalizarRequerimento: false,
  declaroVeracidadeInformacoes: false,
  ehObrigatorioArrendamentoEmbarcacao: "NULL",
  categorias: {
    produtorRural: null,
    indigena: null,
    empregadoRural: null
  },
  condicoesPescador: [],
  titularesEmbarcacao: [],
  arrendamentosEmbarcacao: []
};

const INITIAL_STATE = {
  showModal: false,
  declaracaoSeguradoEspecialTO: novaDeclaracaoSeguradoEspecialTO,
  listaAutoDeclaracoes: [],
  erros: [],
  interessadoTarefaSES: null,
  pendenteSelecaoCategorias: true,
  selecaoCategoriasSetPrimeiroCadastro: false,
  aceiteFinalizarRequerimentoJaInformado: false,
  dadosSeguradoJaInformadoPrimeiroFluxo: false,
  municipiosConsulta: []
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SES_CONTROL_MODAL_SEGURADO_ESPECIAL:
      return {
        ...state,
        showModal: !state.showModal
      };
    case SES_ZERAR_DECLARACAO_SEGURADO_ESPECIAL: {
      return {
        ...state,
        showModal: false,
        declaracaoSeguradoEspecialTO: novaDeclaracaoSeguradoEspecialTO,
        erros: [],
        pendenteSelecaoCategorias: true,
        municipiosConsulta: []
      };
    }
    case SET_ERRO_SEGURADO_ESPECIAL: {
      return {
        ...state,
        erros: action.payload
      };
    }
    case SES_BUSCAR_PERIODO_ATIVIDADE_SUCESSO: {
      return {
        ...state,
        declaracaoSeguradoEspecialTO: {
          ...state.declaracaoSeguradoEspecialTO,
          idPeriodoAtividadeRural: action.payload.idPeriodoAtividadeRural,
          preenchimentoConcluido: action.payload.preenchimentoConcluido,
          dataInicio: action.payload.dataInicio,
          dataFim: action.payload.dataFim,
          exploracaoSustentavel: action.payload.exploracaoSustentavel,
          categoriaAtividade: action.payload.categoriaAtividade,
          condicaoEmRelacaoAoImovel: action.payload.condicaoEmRelacaoAoImovel,
          situacaoFamiliar: action.payload.situacaoFamiliar,
          condicaoNoGrupoFamiliar: action.payload.condicaoNoGrupoFamiliar,
          localDaAtividadeRural: action.payload.localDaAtividadeRural,
          codigoLocalExerceAtividadePescador:
            action.payload.codigoLocalExerceAtividadePescador
        }
      };
    }
    case BUSCAR_DECLARACAO_SEGURADO_ESPECIAL_ERRO: {
      return {
        ...state,
        messageErro: action.payload
      };
    }

    case ATUALIZAR_DECLARACAO_SEGURADO_ESPECIAL: {
      return {
        ...state,
        declaracaoSeguradoEspecialTO: action.payload
      };
    }
    case LISTAR_DECLARACOES_SEGURADO_ESPECIAL_POR_ID_TAREFA_SUCESSO: {
      return {
        ...state,
        listaAutoDeclaracoes: action.payload
      };
    }
    case LISTAR_DECLARACOES_SEGURADO_ESPECIAL_POR_ID_TAREFA_ERRO: {
      return {
        ...state,
        messageErro: action.payload
      };
    }

    //sets Dados Declaração
    case SET_DECLARACAO_SEGURADO_ESPECIAL_ID_TAREFA: {
      return {
        ...state,
        declaracaoSeguradoEspecialTO: {
          ...state.declaracaoSeguradoEspecialTO,
          idTarefa: action.payload
        }
      };
    }
    case SES_CONSULTAR_ID_TAREFA_POR_PROTOCOLO_SUCESSO: {
      return {
        ...state,
        declaracaoSeguradoEspecialTO: {
          ...state.declaracaoSeguradoEspecialTO,
          idTarefa: action.payload
        }
      };
    }
    case SET_DECLARACAO_SEGURADO_ESPECIAL_TIPO_DECLARACAO: {
      return {
        ...state,
        declaracaoSeguradoEspecialTO: {
          ...state.declaracaoSeguradoEspecialTO,
          categoriaAtividade: action.payload
        }
      };
    }
    case SET_DECLARACAO_SEGURADO_ESPECIAL_SITUACAO_FAMILIAR: {
      return {
        ...state,
        declaracaoSeguradoEspecialTO: {
          ...state.declaracaoSeguradoEspecialTO,
          situacaoFamiliar: action.payload
        }
      };
    }
    case SET_DECLARACAO_SEGURADO_ESPECIAL_CONDICAO_IMOVEL: {
      return {
        ...state,
        declaracaoSeguradoEspecialTO: {
          ...state.declaracaoSeguradoEspecialTO,
          condicaoEmRelacaoAoImovel: action.payload
        }
      };
    }
    case SET_DECLARACAO_SEGURADO_ESPECIAL_DT_INICIO: {
      return {
        ...state,
        declaracaoSeguradoEspecialTO: {
          ...state.declaracaoSeguradoEspecialTO,
          dataInicio: action.payload
        }
      };
    }
    case SET_DECLARACAO_SEGURADO_ESPECIAL_DT_FIM: {
      return {
        ...state,
        declaracaoSeguradoEspecialTO: {
          ...state.declaracaoSeguradoEspecialTO,
          dataFim: action.payload
        }
      };
    }

    case SET_DECLARACAO_SEGURADO_ESPECIAL_CODIGO_LOCAL_EXERCE_ATIVIDADE_PESCADOR: {
      return {
        ...state,
        declaracaoSeguradoEspecialTO: {
          ...state.declaracaoSeguradoEspecialTO,
          codigoLocalExerceAtividadePescador: action.payload
        }
      };
    }

    case SET_DECLARACAO_SEGURADO_ESPECIAL_LOCAL_ATIVIDADE_RURAL: {
      return {
        ...state,
        declaracaoSeguradoEspecialTO: {
          ...state.declaracaoSeguradoEspecialTO,
          localDaAtividadeRural: action.payload
        }
      };
    }

    case SET_PERIODO_ATIVIDADE_NUMERO_RGP: {
      return {
        ...state,
        declaracaoSeguradoEspecialTO: {
          ...state.declaracaoSeguradoEspecialTO,
          numeroRGP: action.payload
        }
      };
    }

    case SET_DECLARACAO_SEGURADO_ESPECIAL_NUMERO_RGP: {
      return {
        ...state,
        declaracaoSeguradoEspecialTO: {
          ...state.declaracaoSeguradoEspecialTO,
          dadosSegurado: {
            ...state.declaracaoSeguradoEspecialTO.dadosSegurado,
            numeroRGP: action.payload
          }
        }
      };
    }

    case SET_DECLARACAO_SEGURADO_ESPECIAL_EXPORTACAO_SUSTENTAVEL: {
      return {
        ...state,
        declaracaoSeguradoEspecialTO: {
          ...state.declaracaoSeguradoEspecialTO,
          exploracaoSustentavel: action.payload
        }
      };
    }

    case SET_DECLARACAO_SEGURADO_ESPECIAL_ACEITE_FINALIZAR_REQUERIMENTO: {
      return {
        ...state,
        declaracaoSeguradoEspecialTO: {
          ...state.declaracaoSeguradoEspecialTO,
          aceiteFinalizarRequerimento:
            !state.declaracaoSeguradoEspecialTO.aceiteFinalizarRequerimento
        }
      };
    }

    case SES_CONSULTAR_ADIAR_PREENCHIMENTO_DE_AUTODECLARACAO_SUCESSO: {
      return {
        ...state,
        aceiteFinalizarRequerimentoJaInformado: action.payload,
        declaracaoSeguradoEspecialTO: {
          ...state.declaracaoSeguradoEspecialTO,
          aceiteFinalizarRequerimento: action.payload
        }
      };
    }

    case SES_ADIAR_PREENCHIMENTO_DE_AUTODECLARACAO_SUCESSO: {
      return {
        ...state,
        showModal: false,
        declaracaoSeguradoEspecialTO: {
          ...state.declaracaoSeguradoEspecialTO,
          aceiteFinalizarRequerimento: true
        }
      };
    }

    case SET_DECLARACAO_SEGURADO_ESPECIAL_INFORMACOES_VERDADEIRAS: {
      return {
        ...state,
        declaracaoSeguradoEspecialTO: {
          ...state.declaracaoSeguradoEspecialTO,
          declaroVeracidadeInformacoes:
            !state.declaracaoSeguradoEspecialTO.declaroVeracidadeInformacoes
        }
      };
    }
    case SET_DECLARACAO_SEGURADO_ESPECIAL_EH_PRODUTOR_RURAL_PESCADOR_SERINGUEIRO: {
      return {
        ...state,
        declaracaoSeguradoEspecialTO: {
          ...state.declaracaoSeguradoEspecialTO,
          categorias: {
            ...state.declaracaoSeguradoEspecialTO.categorias,
            produtorRural:
              !state.declaracaoSeguradoEspecialTO.categorias.produtorRural
          }
        }
      };
    }
    case SET_DECLARACAO_SEGURADO_ESPECIAL_EH_INDIGENA: {
      return {
        ...state,
        declaracaoSeguradoEspecialTO: {
          ...state.declaracaoSeguradoEspecialTO,
          categorias: {
            ...state.declaracaoSeguradoEspecialTO.categorias,
            indigena: !state.declaracaoSeguradoEspecialTO.categorias.indigena
          }
        }
      };
    }
    case SET_DECLARACAO_SEGURADO_ESPECIAL_EH_EMPREGADO_RURAL: {
      return {
        ...state,
        declaracaoSeguradoEspecialTO: {
          ...state.declaracaoSeguradoEspecialTO,
          categorias: {
            ...state.declaracaoSeguradoEspecialTO.categorias,
            empregadoRural:
              !state.declaracaoSeguradoEspecialTO.categorias.empregadoRural
          }
        }
      };
    }
    case SET_DECLARACAO_SEGURADO_ESPECIAL_NOME: {
      return {
        ...state,
        declaracaoSeguradoEspecialTO: {
          ...state.declaracaoSeguradoEspecialTO,
          dadosSegurado: {
            ...state.declaracaoSeguradoEspecialTO.dadosSegurado,
            nome: action.payload
          }
        }
      };
    }

    case SET_DECLARACAO_SEGURADO_ESPECIAL_DT_NASCIMENTO_COMPONENTE: {
      return {
        ...state,
        declaracaoSeguradoEspecialTO: {
          ...state.declaracaoSeguradoEspecialTO,
          dadosSegurado: {
            ...state.declaracaoSeguradoEspecialTO.dadosSegurado,
            dataNascimento: action.payload
          }
        }
      };
    }

    case SET_DECLARACAO_SEGURADO_ESPECIAL_LOCAL_NASCIMENTO: {
      return {
        ...state,
        declaracaoSeguradoEspecialTO: {
          ...state.declaracaoSeguradoEspecialTO,
          dadosSegurado: {
            ...state.declaracaoSeguradoEspecialTO.dadosSegurado,
            localNascimento: action.payload
          }
        }
      };
    }
    case SET_DECLARACAO_SEGURADO_ESPECIAL_ENDERECO_RESIDENCIAL: {
      return {
        ...state,
        declaracaoSeguradoEspecialTO: {
          ...state.declaracaoSeguradoEspecialTO,
          dadosSegurado: {
            ...state.declaracaoSeguradoEspecialTO.dadosSegurado,
            endereco: action.payload
          }
        }
      };
    }

    case SET_DECLARACAO_SEGURADO_ESPECIAL_NUMERO_CEI: {
      return {
        ...state,
        declaracaoSeguradoEspecialTO: {
          ...state.declaracaoSeguradoEspecialTO,
          dadosSegurado: {
            ...state.declaracaoSeguradoEspecialTO.dadosSegurado,
            numeroCEI: action.payload
          }
        }
      };
    }

    case SET_DECLARACAO_SEGURADO_ESPECIAL_UF: {
      return {
        ...state,
        declaracaoSeguradoEspecialTO: {
          ...state.declaracaoSeguradoEspecialTO,
          dadosSegurado: {
            ...state.declaracaoSeguradoEspecialTO.dadosSegurado,
            siglaUF: action.payload
          }
        }
      };
    }
    case SET_DECLARACAO_SEGURADO_ESPECIAL_MUNICIPIO: {
      return {
        ...state,
        declaracaoSeguradoEspecialTO: {
          ...state.declaracaoSeguradoEspecialTO,
          dadosSegurado: {
            ...state.declaracaoSeguradoEspecialTO.dadosSegurado,
            numeroMunicipio: action.payload
          }
        }
      };
    }
    case SET_DECLARACAO_SEGURADO_ESPECIAL_NU_RG: {
      return {
        ...state,
        declaracaoSeguradoEspecialTO: {
          ...state.declaracaoSeguradoEspecialTO,
          dadosSegurado: {
            ...state.declaracaoSeguradoEspecialTO.dadosSegurado,
            numeroRG: action.payload
          }
        }
      };
    }

    case SET_DECLARACAO_SEGURADO_ESPECIAL_LOCAL_EXPEDICAO: {
      return {
        ...state,
        declaracaoSeguradoEspecialTO: {
          ...state.declaracaoSeguradoEspecialTO,
          dadosSegurado: {
            ...state.declaracaoSeguradoEspecialTO.dadosSegurado,
            localExpedicaoRg: action.payload
          }
        }
      };
    }

    case SET_DECLARACAO_SEGURADO_ESPECIAL_DATA_EXPEDICAO: {
      return {
        ...state,
        declaracaoSeguradoEspecialTO: {
          ...state.declaracaoSeguradoEspecialTO,
          dadosSegurado: {
            ...state.declaracaoSeguradoEspecialTO.dadosSegurado,
            dataExpedicaoRg: action.payload
          }
        }
      };
    }

    case SET_DECLARACAO_SEGURADO_ESPECIAL_CPF: {
      return {
        ...state,
        declaracaoSeguradoEspecialTO: {
          ...state.declaracaoSeguradoEspecialTO,
          dadosSegurado: {
            ...state.declaracaoSeguradoEspecialTO.dadosSegurado,
            cpf: action.payload
          }
        }
      };
    }

    case SET_DECLARACAO_SEGURADO_ESPECIAL_APELIDO: {
      return {
        ...state,
        declaracaoSeguradoEspecialTO: {
          ...state.declaracaoSeguradoEspecialTO,
          dadosSegurado: {
            ...state.declaracaoSeguradoEspecialTO.dadosSegurado,
            apelido: action.payload
          }
        }
      };
    }
    case SES_CESSAO_DE_TERRA_CADASTRAR_SUCESSO: {
      return {
        ...state,
        declaracaoSeguradoEspecialTO: {
          ...state.declaracaoSeguradoEspecialTO
        }
      };
    }

    //cessão de terra
    case SES_CESSAO_DE_TERRA_LISTAR_SUCESSO: {
      return {
        ...state,
        declaracaoSeguradoEspecialTO: {
          ...state.declaracaoSeguradoEspecialTO,
          cessoesDeTerra: action.payload
        }
      };
    }
    case SES_CESSAO_DE_TERRA_LIMPAR: {
      return {
        ...state,
        declaracaoSeguradoEspecialTO: {
          ...state.declaracaoSeguradoEspecialTO,
          cessoesDeTerra: []
        }
      };
    }
    case SES_CESSAO_DE_TERRA_SET_CONFIRMAR: {
      return {
        ...state,
        declaracaoSeguradoEspecialTO: {
          ...state.declaracaoSeguradoEspecialTO,
          ehObrigatorioCessaoTerra: action.payload
        }
      };
    }

    case SES_CESSAO_DE_TERRA_SET_EXIBIR_MODAL_CESSAO_TERRA_EXCLUSAO: {
      return {
        ...state,
        declaracaoSeguradoEspecialTO: {
          ...state.declaracaoSeguradoEspecialTO,
          exibirModalCessaoTerraExclusao:
            !state.declaracaoSeguradoEspecialTO.exibirModalCessaoTerraExclusao
        }
      };
    }

    //Grupo Familiar
    case SES_GRUPOS_FAMILIARES_LISTAR_SUCESSO: {
      return {
        ...state,
        declaracaoSeguradoEspecialTO: {
          ...state.declaracaoSeguradoEspecialTO,
          gruposFamiliares: action.payload
        }
      };
    }

    case SES_GRUPOS_FAMILIARES_SET_EXIBIR_MODAL_CESSAO_TERRA_EXCLUSAO: {
      return {
        ...state,
        declaracaoSeguradoEspecialTO: {
          ...state.declaracaoSeguradoEspecialTO,
          exibirModalGrupoFamiliaresExclusao:
            !state.declaracaoSeguradoEspecialTO
              .exibirModalGrupoFamiliaresExclusao
        }
      };
    }

    case SES_GRUPOS_FAMILIARES_SET_CONDICAO_GRUPO_FAMILIAR: {
      return {
        ...state,
        declaracaoSeguradoEspecialTO: {
          ...state.declaracaoSeguradoEspecialTO,
          condicaoNoGrupoFamiliar: action.payload
        }
      };
    }

    //cooperativas
    case SES_COOPERATIVA_LISTAR_SUCESSO: {
      return {
        ...state,
        declaracaoSeguradoEspecialTO: {
          ...state.declaracaoSeguradoEspecialTO,
          cooperativas: action.payload
        }
      };
    }

    case SES_COOPERATIVA_SET_CONFIRMAR: {
      return {
        ...state,
        declaracaoSeguradoEspecialTO: {
          ...state.declaracaoSeguradoEspecialTO,
          ehObrigatorioCooperativas: action.payload
        }
      };
    }

    case SES_COOPERATIVA_LIMPAR: {
      return {
        ...state,
        declaracaoSeguradoEspecialTO: {
          ...state.declaracaoSeguradoEspecialTO,
          cooperativas: []
        }
      };
    }

    //atividades rurais

    case SES_LISTAR_ATIVIDADES_RURAIS_SUCESSO: {
      return {
        ...state,
        declaracaoSeguradoEspecialTO: {
          ...state.declaracaoSeguradoEspecialTO,
          atividadesRurais: action.payload
        }
      };
    }

    case SES_RECOLHIMENTO_IPI_LISTAR_SUCESSO: {
      return {
        ...state,
        declaracaoSeguradoEspecialTO: {
          ...state.declaracaoSeguradoEspecialTO,
          recolhimentosIPI: action.payload
        }
      };
    }

    case SES_RECOLHIMENTO_IPI_LIMPAR_SUCESSO: {
      return {
        ...state,
        declaracaoSeguradoEspecialTO: {
          ...state.declaracaoSeguradoEspecialTO,
          recolhimentosIPI: []
        }
      };
    }

    case SES_RECOLHIMENTO_IPI_SET_CONFIRMAR: {
      return {
        ...state,
        declaracaoSeguradoEspecialTO: {
          ...state.declaracaoSeguradoEspecialTO,
          ehObrigatorioRecolhimentosIPI: action.payload
        }
      };
    }

    case SES_PROPRIEDADE_RURAL_LISTAR_SUCESSO: {
      return {
        ...state,
        declaracaoSeguradoEspecialTO: {
          ...state.declaracaoSeguradoEspecialTO,
          propriedadesRurais: action.payload
        }
      };
    }

    case SES_PROPRIEDADE_RURAL_SET_EXIBIR_MODAL_CESSAO_TERRA_EXCLUSAO: {
      return {
        ...state,
        declaracaoSeguradoEspecialTO: {
          ...state.declaracaoSeguradoEspecialTO,
          exibirModalPropriedadesRuraisExclusao:
            !state.declaracaoSeguradoEspecialTO
              .exibirModalPropriedadesRuraisExclusao
        }
      };
    }

    case BUSCAR_DADOS_SEGURADOS_ESPECIAL_SUCESSO: {
      return {
        ...state,
        interessadoTarefaSES: action.payload
      };
    }
    case SES_CONSULTAR_DADOS_INTERESSADOS_SUCESSO: {
      let segurado = action.payload;
      return {
        ...state,
        interessadoTarefaSES: action.payload,
        declaracaoSeguradoEspecialTO: {
          ...state.declaracaoSeguradoEspecialTO,
          dadosSegurado: {
            ...state.declaracaoSeguradoEspecialTO.dadosSegurado,
            cpf: segurado.cpf,
            nome: segurado.nome,
            dataNascimento: segurado.dataNascimento
          }
        }
      };
    }
    case SES_CONSULTAR_DADOS_SEGURADO_SUCESSO: {
      if (action.payload) {
        return {
          ...state,
          declaracaoSeguradoEspecialTO: {
            ...state.declaracaoSeguradoEspecialTO,
            dadosSegurado: action.payload,
            dadosSeguradoJaInformadoPrimeiroFluxo: false
          }
        };
      }
      return {
        ...state
      };
    }
    case SES_CADASTRAR_DADOS_SEGURADO_SUCESSO: {
      return {
        ...state,
        declaracaoSeguradoEspecialTO: {
          ...state.declaracaoSeguradoEspecialTO,
          dadosSegurado: action.payload,
          dadosSeguradoJaInformadoPrimeiroFluxo: true
        }
      };
    }
    case SES_CADASTRAR_NUMERO_RGP_SUCESSO: {
      return {
        ...state,
        declaracaoSeguradoEspecialTO: {
          ...state.declaracaoSeguradoEspecialTO,
          dadosSegurado: {
            ...state.declaracaoSeguradoEspecialTO.dadosSegurado,
            numeroRGP: action.payload
          }
        }
      };
    }

    case SES_CONSULTAR_CATEGORIAS_ATIVIDADE_RURAL_SUCESSO: {
      let pendenteSelecaoCategorias = false;
      if (
        !action.payload.produtorRural &&
        !action.payload.indigena &&
        !action.payload.empregadoRural
      ) {
        pendenteSelecaoCategorias = true;
      }

      return {
        ...state,
        pendenteSelecaoCategorias: pendenteSelecaoCategorias,
        declaracaoSeguradoEspecialTO: {
          ...state.declaracaoSeguradoEspecialTO,
          categorias: {
            ...state.declaracaoSeguradoEspecialTO.categorias,
            produtorRural: action.payload.produtorRural,
            empregadoRural: action.payload.empregadoRural,
            indigena: action.payload.indigena
          }
        }
      };
    }
    case SES_CATEGORIAS_DECLARACAO_SUCESSO: {
      return {
        ...state,
        selecaoCategoriasSetPrimeiroCadastro: true
      };
    }

    case SES_SELECAO_CATEGORIAS_SET_PRIMEIRO_CADASTRO: {
      return {
        ...state,
        selecaoCategoriasSetPrimeiroCadastro: action.payload
      };
    }

    case CADASTRAR_PERIODO_DECLARACAO_SEGURADO_ESPECIAL_SUCESSO: {
      return {
        ...state,
        declaracaoSeguradoEspecialTO: {
          ...state.declaracaoSeguradoEspecialTO,
          idPeriodoAtividadeRural: action.payload.idPeriodoAtividadeRural
        }
      };
    }

    case SES_CONSULTAR_MUNICIPIOS_POR_UF_SUCESSO: {
      return {
        ...state,
        municipiosConsulta: action.payload
      };
    }

    case SES_PROPRIEDADE_RURAL_LIMPAR: {
      return {
        ...state,
        declaracaoSeguradoEspecialTO: {
          ...state.declaracaoSeguradoEspecialTO,
          propriedadesRurais: []
        }
      };
    }

    case SES_LIMPAR_GRUPOS_FAMILIARES: {
      return {
        ...state,
        declaracaoSeguradoEspecialTO: {
          ...state.declaracaoSeguradoEspecialTO,
          gruposFamiliares: []
        }
      };
    }

    case SES_LIMPAR_ATIVIDADES_RURAIS: {
      return {
        ...state,
        declaracaoSeguradoEspecialTO: {
          ...state.declaracaoSeguradoEspecialTO,
          atividadesRurais: []
        }
      };
    }

    //empregados ou prestadores de serviço

    case SES_EMPREGADO_LIMPAR_SUCESSO: {
      return {
        ...state,
        declaracaoSeguradoEspecialTO: {
          ...state.declaracaoSeguradoEspecialTO,
          empregadosOuPrestadores: []
        }
      };
    }

    case SES_EMPREGADO_SET_CONFIRMAR: {
      return {
        ...state,
        declaracaoSeguradoEspecialTO: {
          ...state.declaracaoSeguradoEspecialTO,
          ehObrigatorioEmpregadosPrestadoresServicos: action.payload
        }
      };
    }

    case SES_EMPREGADO_LISTAR_SUCESSO: {
      return {
        ...state,
        declaracaoSeguradoEspecialTO: {
          ...state.declaracaoSeguradoEspecialTO,
          empregadosOuPrestadores: action.payload
        }
      };
    }

    case SES_EXERCE_ATIVIDADE_RECEBE_OUTRA_RENDA_ESPECIFICA_LIMPAR: {
      return {
        ...state,
        declaracaoSeguradoEspecialTO: {
          ...state.declaracaoSeguradoEspecialTO,
          atividadesEspecificas: []
        }
      };
    }

    case SES_OUTRAS_ATIVIDADES_ESPECIFICA_SET_CONFIRMAR: {
      return {
        ...state,
        declaracaoSeguradoEspecialTO: {
          ...state.declaracaoSeguradoEspecialTO,
          ehObrigatorioAtividadesEspecificas: action.payload
        }
      };
    }

    case SES_OUTRAS_ATIVIDADES_SET_CONFIRMAR: {
      return {
        ...state,
        declaracaoSeguradoEspecialTO: {
          ...state.declaracaoSeguradoEspecialTO,
          ehObrigatorioOutrasAtividades: action.payload
        }
      };
    }

    case SES_OUTRAS_ATIVIDADES_LISTAR_SUCESSO: {
      return {
        ...state,
        declaracaoSeguradoEspecialTO: {
          ...state.declaracaoSeguradoEspecialTO,
          outrasAtividades: action.payload
        }
      };
    }

    case SES_LISTAR_EXERCE_ATIVIDADE_RECEBE_OUTRA_RENDA_ESPECIFICA_SUCESSO: {
      return {
        ...state,
        declaracaoSeguradoEspecialTO: {
          ...state.declaracaoSeguradoEspecialTO,
          atividadesEspecificas: action.payload
        }
      };
    }
    case SES_RELACAO_PESCADOR_EMBARCACAO_CADASTRAR_SUCESSO: {
      return {
        ...state,
        declaracaoSeguradoEspecialTO: {
          ...state.declaracaoSeguradoEspecialTO
        }
      };
    }
    case SES_CONDICAO_PESCADOR_EMBARCACAO_LISTAR_SUCESSO: {
      return {
        ...state,
        declaracaoSeguradoEspecialTO: {
          ...state.declaracaoSeguradoEspecialTO,
          condicoesPescador: action.payload
        }
      };
    }
    case SES_CONDICAO_PESCADOR_EMBARCACAO_LIMPAR: {
      return {
        ...state,
        declaracaoSeguradoEspecialTO: {
          ...state.declaracaoSeguradoEspecialTO,
          condicoesPescador: []
        }
      };
    }

    // titular de embarcação

    case SES_TITULAR_LISTAR_SUCESSO: {
      return {
        ...state,
        declaracaoSeguradoEspecialTO: {
          ...state.declaracaoSeguradoEspecialTO,
          titularesEmbarcacao: action.payload
        }
      };
    }
    case SES_TITULAR_LIMPAR_SUCESSO: {
      return {
        ...state,
        declaracaoSeguradoEspecialTO: {
          ...state.declaracaoSeguradoEspecialTO,
          titularesEmbarcacao: []
        }
      };
    }

    // arrendamento de embarcação

    case SES_ARRENDAMENTO_EMBARCACAO_SET_CONFIRMAR: {
      return {
        ...state,
        declaracaoSeguradoEspecialTO: {
          ...state.declaracaoSeguradoEspecialTO,
          ehObrigatorioArrendamentoEmbarcacao: action.payload
        }
      };
    }

    case SES_ARRENDAMENTO_EMBARCACAO_LISTAR_SUCESSO: {
      return {
        ...state,
        declaracaoSeguradoEspecialTO: {
          ...state.declaracaoSeguradoEspecialTO,
          arrendamentosEmbarcacao: action.payload
        }
      };
    }
    case SES_ARRENDAMENTO_EMBARCACAO_LIMPAR_SUCESSO: {
      return {
        ...state,
        declaracaoSeguradoEspecialTO: {
          ...state.declaracaoSeguradoEspecialTO,
          arrendamentosEmbarcacao: []
        }
      };
    }
    case SET_DECLARACAO_SEGURADO_ESPECIAL_PESSOA_QUILOMBOLA: {
      const codigoQuilombola = getCodigoValuePorEnumValue(
        "QUILOMBOLA",
        condicaoEmRelacaoAoImovelEnum
      );

      const { condicaoEmRelacaoAoImovel } = state.declaracaoSeguradoEspecialTO;

      return {
        ...state,
        declaracaoSeguradoEspecialTO: {
          ...state.declaracaoSeguradoEspecialTO,
          condicaoEmRelacaoAoImovel: action.payload === 'SIM' ? codigoQuilombola : condicaoEmRelacaoAoImovel
        }
      };
    }

    default:
      return state;
  }
};
